import { useState } from "react";

import { VerticalContainer } from "../../../components/styled";
import VeiculosForm from "../../../components/veiculos/form";
import { registerVeiculo } from "../../../services/veiculos";

export default function AddVeiculo(props) {
  const veiculo = props.location.state;

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const onFinish = async (values) => {
    try {
      setLoading(true);
      return await registerVeiculo(values);
    } catch (err) {
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <VerticalContainer>
      <div />
      <VeiculosForm
        initialValues={veiculo}
        onFinish={onFinish}
        error={error}
        setError={setError}
        loading={loading}
      />
    </VerticalContainer>
  );
}
